import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CssFetcherService {
    private readonly httpClient = inject(HttpClient);

    fetchCss(cssFileName: string): Observable<string> {
        const cssUrl = `${cssFileName}.css`;
        return this.httpClient.get(cssUrl, { responseType: 'text' }).pipe(
            map(() => cssUrl),
            catchError(() => of('default.css')),
        );
    }
}
